import React, { ComponentProps } from 'react';
import { AppIconElement, AppIconList } from '../../../_lib/components/AppIconList';
import { asView } from '../../../_lib/ViewFetcher';

export type AppLibraryDefaultViewProps = { mandatoryItems?: AppIconElement[], optionalItems?: AppIconElement[] };

export function AppLibraryDefault({ mandatoryItems, optionalItems }: AppLibraryDefaultViewProps) {
  const items = mandatoryItems?.concat(optionalItems ?? []);
  if (!items || items.length === 0) {
    return null;
  }
  return <AppIconList items={items} />;
}
export const AppLibraryDefaultView = asView(AppLibraryDefault);
export type AppLibraryDefaultView = ComponentProps<typeof AppLibraryDefaultView>;
